export enum UserKey {
    MOBILE = 'mobile',
    TEAMS = 'teams',
    ACTIVEHIERARCHYNAME = 'activeHierarchyName',
    ACTIVEHIERARCHYID = 'activeHierarchyId',
}